import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#007BFF] text-white py-8 mut-40">
      <div className="px-4 sm:px-6 lg:px-8 container mx-auto flex flex-wrap my-20">
        <div className="w-full md:w-1/4 text-center md:text-left">
          <h3 className="uppercase mb-4 text-xl font-bold my-3 font-workSans md:text-left">
            About Us
          </h3>
          <ul className="list-reset md:text-left">
            <li className="mb-3 font-workSans">
              <Link to="/">About Time Shoppy</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">We are hiring!</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Terms and Conditions</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Privacy Policy</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Billing Policy</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Cookie Policy</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Copyright Infringement Policy</Link>
            </li>
          </ul>
        </div>
        <div className="w-full md:w-1/4 text-center md:text-left">
          <h3 className="uppercase mb-4 text-xl font-bold my-3 font-workSans md:text-left">
            Support
          </h3>
          <ul className="list-reset md:text-left">
            <li className="mb-3 font-workSans">
              <Link to="/">support@timeshoppy.ng</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Contact Us</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">FAQ</Link>
            </li>
          </ul>
        </div>
        <div className="w-full md:w-1/4 text-center md:text-left">
          <h3 className="uppercase mb-4 text-xl font-bold my-3 font-workSans md:text-left">
            Our resources
          </h3>
          <ul className="list-reset md:text-left">
            <li className="mb-3  font-workSans">
              <Link to="/">Our blog</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Facebook</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Instagram</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Twitter</Link>
            </li>
          </ul>
        </div>
        <div className="w-full md:w-1/4 text-center md:text-left">
          <h3 className="uppercase mb-4 text-xl font-bold my-3 font-workSans md:text-left">
            Our resources
          </h3>
          <ul className="list-reset md:text-left">
            <li className="mb-3  font-workSans">
              <Link to="/">Our blog</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Facebook</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Instagram</Link>
            </li>
            <li className="mb-3 font-workSans">
              <Link to="/">Twitter</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
